import { createContext, useEffect, useState } from "react";
import { useAuth } from "../auth/useAuth";

export const AvatarContext = createContext(null);

const generateAvatarColor = () => {
  const hue = Math.floor(Math.random() * 360);
  const saturation = 65 + Math.random() * 10;
  const lightness = 45 + Math.random() * 10;
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

export const AvatarProvider = ({ children }) => {
  const { user } = useAuth();

  const [avatar, setAvatar] = useState(null);
  const [avatarColor, setAvatarColor] = useState("");

  /* ----------------------------
     Load avatar (per user)
  ---------------------------- */
  useEffect(() => {
    if (!user) return;

    const avatarKey = `profileAvatar_${user.id || user.email}`;
    const savedAvatar = localStorage.getItem(avatarKey);

    if (savedAvatar) {
      setAvatar(savedAvatar);
    }
  }, [user?.id, user?.email,user]);

  /* ----------------------------
     Avatar background color
  ---------------------------- */
  useEffect(() => {
    let color;

    const userKey =
      user?.id || user?.email
        ? `avatarColor_${user.id || user.email}`
        : null;

    const fallbackKey = "avatarColor_fallback";

    if (userKey) {
      const savedUserColor = localStorage.getItem(userKey);
      if (savedUserColor) {
        setAvatarColor(savedUserColor);
        return;
      }
    }

    const fallbackColor = localStorage.getItem(fallbackKey);
    if (fallbackColor) {
      setAvatarColor(fallbackColor);

      if (userKey) {
        localStorage.setItem(userKey, fallbackColor);
        localStorage.removeItem(fallbackKey);
      }
      return;
    }

    color = generateAvatarColor();

    if (userKey) {
      localStorage.setItem(userKey, color);
    } else {
      localStorage.setItem(fallbackKey, color);
    }

    setAvatarColor(color);
  }, [user?.id, user?.email]);

  /* ----------------------------
     Save avatar helper
  ---------------------------- */
  const updateAvatar = (dataUrl) => {
    if (!user) return;

    const avatarKey = `profileAvatar_${user.id || user.email}`;
    localStorage.setItem(avatarKey, dataUrl);
    setAvatar(dataUrl);
  };

  return (
    <AvatarContext.Provider
      value={{
        avatar,
        setAvatar: updateAvatar, // 🔥 THIS FIXES YOUR ERROR
        avatarColor,
      }}
    >
      {children}
    </AvatarContext.Provider>
  );
};
